import BaseApi from './base.api'
import ApiUrls from './urls.api'

export default {

    Audit: {
        GetChangeStatus: function(formId) {
            return BaseApi.get(`${ApiUrls.Client.Audit.GetChangeStatus}${formId}`)
        },

        PostAddTradePoint: function(auditId, tradePointDto) {
            return BaseApi.post(`${ApiUrls.Client.Audit.PostAddTradePoint}?auditId=${auditId}`, tradePointDto)
        },
        PostUpdateComment: function(comment) {
            return BaseApi.post(ApiUrls.Client.Audit.PostUpdateComment, comment)
        },
        PostCreate: function (activityId, auditLocalTimeZone) {
            return BaseApi.post(`${ApiUrls.Client.Audit.PostCreate}?activityId=${activityId}&LocalTimeZone=${auditLocalTimeZone}`)
        },
        PostDelete: function(auditId) {
            return BaseApi.post(`${ApiUrls.Client.Audit.PostDelete}?id=${auditId}`)
        },
        PostComplete: function (auditId) {
            return BaseApi.post(`${ApiUrls.Client.Audit.PostComplete}?id=${auditId}`)
        },
        PostSend: function (auditId) {
            return BaseApi.post(`${ApiUrls.Client.Audit.PostSend}?id=${auditId}`)
        },
        
        Get: function (auditId) {
            return BaseApi.get(`${ApiUrls.Client.Audit.Get}?id=${auditId}`)
        },      
        GetDaxUsers: function() {
            return BaseApi.get(`${ApiUrls.Client.Audit.GetDaxUsers}`)
        }

    },

    Activities: {
        GetTags: function() {
            return BaseApi.get(ApiUrls.Client.Activities.GetTags)
        }
    },

    Feed: {
        PostDelete: function() {
            return BaseApi.post(ApiUrls.Client.Feed.PostDelete)
        },

        GetAll: function() {
            return BaseApi.get(ApiUrls.Client.Feed.GetAll)
        }
    },

    Form: {

        PostComplete: function (auditId, formId) {
            return BaseApi.post(`${ApiUrls.Client.Form.PostComplete}?auditId=${auditId}&formId=${formId}`)
        },

        PostQuestion: function (questionDto, auditId, formId, isNext) {
            return BaseApi.post(`${ApiUrls.Client.Form.PostQuestion}?auditId=${auditId}&formId=${formId}&isNext=${isNext}`, questionDto)
        },

        PostUpdateComment: function(commentDto) {
            return BaseApi.post(ApiUrls.Client.Form.PostUpdateComment, commentDto)
        },

        PostDelete: function(auditId, formId) {
            return BaseApi.post(`${ApiUrls.Client.Form.PostDelete}?auditId=${auditId}&formId=${formId}`)
        },

        Get: function(auditId, formId) {
            return BaseApi.get(`${ApiUrls.Client.Form.Get}?auditId=${auditId}&formId=${formId}`)
        },

        GetQuestion: function(auditId, formId, questionId) {
            return BaseApi.get(`${ApiUrls.Client.Form.GetQuestion}?auditId=${auditId}&formId=${formId}&questionId=${questionId}`)
        },
        
        
        PostConfirmMagnit: function (auditId, formId) {
            return BaseApi.post(`${ApiUrls.Client.Form.PostConfirmMagnit}?auditId=${auditId}&formId=${formId}`)
        }

        // GetOpen: function(formId) {
        //     return BaseApi.get(ApiUrls.Client.Form.GetOpen, formId)
        // },

        // GetContacts: function () {
        //     return BaseApi.get(ApiUrls.Client.Form.GetContacts)
        // },

        // GetAeps: function (formId, answerType) {
        //     return BaseApi.get(`${ApiUrls.Client.Form.GetAeps}?formId=${formId}&answerType=${answerType}`)
        // },

        // GetCreateTask: function(tradePointId, formId) {
        //     return BaseApi.get(`${ApiUrls.Client.Form.GetCreateTask}?tradePointId=${tradePointId}&formId=${formId}`)
        // },

        // GetCompleteTask: function(taskId) {
        //     return BaseApi.get(ApiUrls.Client.Form.GetCompleteTask, taskId)
        // }
    },

    Help: {

        Get: function () {
            return BaseApi.get(`${ApiUrls.Client.Help.Get}`)
        },

        GetDependency: function() {
            return BaseApi.get(ApiUrls.Client.Help.GetDependency)
        }

    },

    Gallery: {

        PostUpdate: function(auditId, formId, photoDto) {
            return BaseApi.post(`${ApiUrls.Client.Gallery.PostUpdate}?auditId=${auditId}&formId=${formId}`, photoDto)
        },

        PostDelete: function(auditId, formId, photoId) {
            return BaseApi.post(`${ApiUrls.Client.Gallery.PostDelete}?auditId=${auditId}&formId=${formId}&photoId=${photoId}`)
        },

        GetGallery: function(auditId, formId) {
            return BaseApi.get(`${ApiUrls.Client.Gallery.GetGallery}?auditId=${auditId}&formId=${formId}`)
        },

        GetPhoto: function(photoId) {
            return BaseApi.get(`${ApiUrls.Client.Gallery.GetPhoto}?id=${photoId}`)
        }
    },

    Photos: {
        PostUpdate: function(photoDto) {
            return BaseApi.post(ApiUrls.Client.Photos.PostUpdate, photoDto)
        },

        GetCategories: function() {
            return BaseApi.get(ApiUrls.Client.Photos.GetCategories)
        }
    },

    TradePoints: {
        
        PostUpdate: function(tradePointDto) {
            return BaseApi.post(ApiUrls.Client.TradePoints.PostUpdate, tradePointDto)
        },
        
        PostFilter: function(ttFilter) {
            return BaseApi.post(ApiUrls.Client.TradePoints.PostFilter, ttFilter)
        },

        Get: function(tradePointId) {
            return BaseApi.get(`${ApiUrls.Client.TradePoints.Get}?id=${tradePointId}`)
        },

        GetSegments: function(subType) {
            return BaseApi.get(`${ApiUrls.Client.TradePoints.GetSegments}?subType=${subType}`)
        },

        GetSegment: function(subType, code) {
            return BaseApi.get(`${ApiUrls.Client.TradePoints.GetSegment}?subType=${subType}&code=${code}`)
        },

        GetCheckUser: function() {
            return BaseApi.get(ApiUrls.Client.TradePoints.GetCheckUser)
        },

        TodoCategories: {
            GetAll: function() {
                return BaseApi.get(ApiUrls.Client.TradePoints.TodoCategories.GetAll)
            },
            PostUpdate: function(auditId, formId, todoDto) {
                return BaseApi.post(`${ApiUrls.Client.TradePoints.TodoCategories.PostUpdate}?auditId=${auditId}&formId=${formId}`, todoDto)
            }
        }


    },

    Users: {
        
        GetBranches: function() {
            return BaseApi.get(ApiUrls.Client.Users.GetBranches)
        },

        GetCenter: function() {
            return BaseApi.get(ApiUrls.Client.Users.GetCenter)
        },

        GetSubordinatesEmployees: function() {
            return BaseApi.get(ApiUrls.Client.Users.GetSubordinatesEmployees)
        }
    },

    Settings: {

        PostSave: function(settingsDto) {
            return BaseApi.post(ApiUrls.Client.Settings.PostSave, settingsDto)
        },

        Get: function() {
            return BaseApi.get(ApiUrls.Client.Settings.Get)
        }

    }


}